import { useSyncExternalStore } from 'react'

// The sidebar badge reads the waiting count from here, so the sidebar needs no data client.
let waitingCount = 0
const listeners = new Set<() => void>()

export function setWaitingCount(count: number) {
  if (count === waitingCount) return
  waitingCount = count
  listeners.forEach((listener) => listener())
}

/** Chats waiting on a person's reply, for the sidebar badge. */
export function useChatsWaitingCount() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => waitingCount,
    () => 0,
  )
}

